module.exports = __webpack_public_path__ + "img/jz_disease.194d123b.png";